import React from 'react';

// @ts-expect-error less import
import style from './style.module.less';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export const ShopperTasks = ({ children }) => <div className={style['shopper-tasks']}>{children}</div>;
